import script from "./ImagePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImagePreview.vue?vue&type=script&setup=true&lang=ts"

import "./ImagePreview.vue?vue&type=style&index=0&id=11889a47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11889a47"]])

export default __exports__